// with pushState/replaceState, document.referrer no longer works reliably
// thus, with this little helper we keep track of previous/current url for BI
const isSSR = typeof document === 'undefined' || typeof window === 'undefined';
let referrer = isSSR ? undefined : document.referrer;
let previousUrl = referrer;
let currentUrl = isSSR ? undefined : window.location.href;
export function updateReferrer() {
    if (isSSR || window.location.href === currentUrl) {
        return;
    }
    previousUrl = currentUrl;
    currentUrl = window.location.href;
}
export function commitReferrer() {
    referrer = previousUrl;
}
export function getReferrer() {
    return referrer;
}
